import { createMiddlewareAction } from "./createMiddlewareAction"
import { endpoints } from "../api/endpoints"
import { tasksTypes } from "../constantes/actionTypes"

export const tasksActions = {
    getAllTasks: (userId, eventId) => (
        createMiddlewareAction({
            successType: tasksTypes.GET_ALL_TASKS_SUCCESS,
            failureType: tasksTypes.GET_ALL_TASKS_FAILURE,
            method: "GET",
            endpoint: endpoints.GET_ALL_TASKS(userId, eventId)
        })
    ),
    getAllTasksByEventPaged: (userId,eventId, search, page) => (
      createMiddlewareAction({
          successType: tasksTypes.GET_ALL_TASKS_BY_EVENT_PAGED_SUCCESS,
          failureType: tasksTypes.GET_ALL_TASKS_BY_EVENT_PAGED_FAILURE,
          method: "GET",
          endpoint: endpoints.GET_ALL_TASKS_BY_EVENT_PAGED(userId, eventId, search, page)
      })
    ),
    newTask: (task) => (
      createMiddlewareAction({
          successType: tasksTypes.NEW_TASK_SUCCESS,
          failureType: tasksTypes.NEW_TASK_FAILURE,
          method: "POST",
          endpoint: endpoints.NEW_TASKS,
          body: task
      })
    ),
    updateTask: (task) => (
      createMiddlewareAction({
          successType: tasksTypes.UPDATE_TASK_SUCCESS,
          failureType: tasksTypes.UPDATE_TASK_FAILURE,
          method: "PUT",
          endpoint: endpoints.UPDATE_TASKS,
          body: task
      })
    ),
    deleteTask: (idTask) => (
      createMiddlewareAction({
          successType: tasksTypes.DELETE_TASK_SUCCESS,
          failureType: tasksTypes.DELETE_TASK_FAILURE,
          method: "DELETE",
          endpoint: endpoints.DELETE_TASKS(idTask),
      })
    ),
    clearTasksList: () => ({
        type: tasksTypes.CLEAR_TASKS_LIST 
    }) 
}